import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_FORM_GROUP_SUPPORTING_DOCS_REQUEST = 'GET_FORM_GROUP_SUPPORTING_DOCS_REQUEST';
export const GET_FORM_GROUP_SUPPORTING_DOCS_SUCCESS = 'GET_FORM_GROUP_SUPPORTING_DOCS_SUCCESS';
export const GET_FORM_GROUP_SUPPORTING_DOCS_FAILURE = 'GET_FORM_GROUP_SUPPORTING_DOCS_FAILURE';

function request() {
  return {
    type: GET_FORM_GROUP_SUPPORTING_DOCS_REQUEST
  };
}

function receive(supportingDocs) {
  return {
    type: GET_FORM_GROUP_SUPPORTING_DOCS_SUCCESS,
    supportingDocs,
  };
}

function reject(formError) {
  return {
    type: GET_FORM_GROUP_SUPPORTING_DOCS_FAILURE,
    formError
  };
}

export function getFormGroupSupportingDocs(formGroupId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getSupportingDocsByFormGroupId(formGroupId)
      .then((response) => {
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const code = error.response && error.response.data && error.response.data.error && error.response.data.error.code;
          if (code !== 401) {
            dispatch(handleException(error, reject, !code || (code !== 404 && code !== 401)));
          }
        }
      });

    return promise();
  };
}
